import React from "react";
import "./UserCollectedData.css";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import { Box, Tabs, Tab } from "@mui/material";
import SavedSearchesTab from "./savedSearchesTab/SavedSearchesTab";
import NotificationsTab from "./notificationsTab/NotificationsTab";
import TrackedApplicationsTab from "./trackedTab/TrackedApplicationsTab";
import { atom, useRecoilState } from "recoil";

enum UserDataTabNames {
    "My Searches" = "My Searches",
    "My Notifications" = "My Notifications",
    "My Tracks" = "My Tracks",
}

const userCollectedDataTabs = atom({
    key: "userCollectedDataTabs",
    default: UserDataTabNames["My Searches"],
});

const UserCollectedData = () => {
    const [currentTab, changeTab] = useRecoilState<UserDataTabNames>(userCollectedDataTabs);
    const onTabChange = (event: React.SyntheticEvent, newTab: UserDataTabNames) => {
        changeTab(newTab);
    };
    return (
        <>
            <ResponsiveAppBar />
            <Board size="big">
                <Box className="collected-data-board-content">
                    {getTabs()}
                    {getTabContent()}
                </Box>
            </Board>
        </>
    );

    function getTabContent() {
        switch (currentTab) {
            case UserDataTabNames["My Searches"]:
                return <SavedSearchesTab />;
            case UserDataTabNames["My Notifications"]:
                return <NotificationsTab />;
            case UserDataTabNames["My Tracks"]:
                return <TrackedApplicationsTab />;
            default:
                throw Error(`Wrong Tab Name on getTabContent - ${currentTab}`);
        }
    }

    function getTabs() {
        return (
            <Tabs value={currentTab} onChange={onTabChange} aria-label="user-collected-data-navigation-tabs" centered={true} className="collected-data-tabs">
                <Tab disableRipple label="My Searches" value={"My Searches"} />
                <Tab disableRipple label="My Notifications" value={"My Notifications"} />
                <Tab disableRipple label="My Tracks" value={"My Tracks"} />
            </Tabs>
        );
    }
};

export default UserCollectedData;
